import { useEffect } from 'react'

import { useLocation } from 'react-router-dom'

import { useAudioContext } from 'audioContext'
import { useAppContext } from 'context'
import { useBundleData } from 'hooks/useBundle'
import { useReferredState } from 'hooks/useReferredState'

import { MainPlayer } from './components/MainPlayer'

export { MainPlayer } from './components/MainPlayer'

export const SmallPlayer = () => {
  const { contentLoaded } = useAppContext()
  const { audioStoryId, playing, setShowPlayer, showPlayer, audioUrl } =
    useAudioContext()
  const { getAudioStory } = useBundleData()
  const location = useLocation()

  const [data, setData] = useReferredState<ReturnType<
    typeof getAudioStory
  > | null>(null)

  useEffect(() => {
    if (contentLoaded && audioStoryId) {
      const audioStory = audioStoryId ? getAudioStory(audioStoryId) : null
      setData(audioStory)
    }
  }, [audioStoryId, contentLoaded, audioUrl])

  useEffect(() => {
    if (location.pathname.includes('/stories/') || !audioUrl) {
      setShowPlayer(false)
    }
    if (!location.pathname.includes('/stories/') && playing && audioUrl) {
      setShowPlayer(true)
    }
  }, [playing, location, showPlayer, audioUrl])
  const audioData = data.current
  if (!showPlayer) return null
  return <MainPlayer small {...audioData} />
}
